// @ts-nocheck
'use strict';
//***********************************************************************************
//***********************************************************************************
//**** cn_tool markers : a tool to create markers in 3D
//***********************************************************************************
//***********************************************************************************

import { cn_element } from '../model/cn_element';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_marker } from '../model/cn_marker';
import { cn_contour } from '../model/cn_contour';
import { cnx_clone } from '../utils/cn_utilities';
import { cn_camera } from './cn_camera';
import { cn_storey } from '../model/cn_storey';
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_polygon_handler } from './cn_polygon_handler';
import { cn_marker_handler } from './cn_marker_handler';
import { cn_freeform_handler } from './cn_freeform_handler';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_roof } from '../model/cn_roof';
import { CN_CURRENT_DATE } from '../utils/cn_transaction_manager';
import { logger } from '../utils/cn_logger';
import { HELPER } from '../utils/cn_wordings';
import { cn_user_measure } from '../model/cn_user_measure';
import { cn_user_measure_handler } from './cn_user_measure_handler';

export const DEFAULT_MARKER_TITLE = 'Nouvelle annotation';

export const CN_MARKER_MODES = [
    { label: "Commentaire", code: "marker", mtype: "" },
    { label: "Rectangle", code: "rectangle", mtype: "" },
    { label: "Étiquette", code: "label", mtype: "label" },
    { label: "Pastille", code: "chip", mtype: "chip" },
    { label: "Liaison", code: "liaison", mtype: "liaison" },
    { label: "Chemin", code: "metop", mtype: "metop" },
    { label: "Recouvrement", code: "eraser", mtype: "eraser" }
];

export class cn_svg_tool_user_measure_creation extends cn_svg_tool_creation {
    //***********************************************************************************
    /**
     * Constructor
     */
    constructor(map) {
        super(map);

        this._force_freeform = false;

        //this.accept_all_events = true;
        this.element_filter = element => element.constructor == cn_user_measure;

        this._hooks = [null];
    }

    //***********************************************************************************
    //**** Open tool
    //***********************************************************************************
    open_tool() {
        super.open_tool();
        this._terminate_edition();
        this._initialize_creation();
    }

    close_tool() {
        super.close_tool();
    }

    //*****************************************************************
    //*** Must return 'true' if wa are in modal creation.
    //*****************************************************************
    is_creating() {
        return (this._handler && this._handler.is_creating());
    }

    //***********************************************************************************
    //**** transaction refresh
    //***********************************************************************************
    transaction_refresh() {
        this._terminate_edition();
    }

    //***********************************************************************************
    /**
     * Draws  specific svg for the tool. Returns svg string
     * @param {cn_camera} camera
     * @returns {string}
     */
    draw(camera) {
        let html = '';

        if (this._hooks[this._hooks.length-1])
        {
            html += camera.draw_move_arrow(this._hooks[this._hooks.length-1].position);
            if (this._hooks.length >= 2)
            {
                html += camera.draw_measure(this._hooks[0].position,this._hooks[1].position,null, false,0);
            }
        }

        html += super.draw(camera);

        return html;
    }

    //***********************************************************************************
    /** clear move effects
     */
    clear_move() {
        if (this._ghost)
            this._ghost.element = null;
        super.clear_move();
    }

    move(mouse_event) {
        
        if (this._view_overlay)
        {
            let other_hook = (this._hooks.length>1)?this._hooks[0]:null;
            
            let hook = this._view_overlay._renderer.get_hook(mouse_event.mouse_screen[0], mouse_event.mouse_screen[1],10,other_hook);
            if (hook) {
                this._hooks[this._hooks.length-1] = hook;
                return true;
            }
            return false;
        }
        return false;
    }

    drag(mouse_event) {
        return this.move(mouse_event);
    }
    
    grab(mouse_event) {
        return this.move(mouse_event);
    }
    
    click(mouse_event) {
        return this.drop(mouse_event);
    }

    drop(mouse_event) {
        
        if (this._view_overlay)
        {
            if (this._hooks.length == 1)
            {
                if (this._hooks[0]) this._hooks.push(null);
            }
            else if (this._hooks[1]) {
                let user_measure = new cn_user_measure(this._view_overlay._building);
                for (var n=0;n<2;n++)
                {
                    user_measure.positions[n] = this._hooks[n].position;
                    user_measure.normals[n] = this._hooks[n].normals;
                }
                this._view_overlay._building.user_measures.push(user_measure);
                this.call('creation', [user_measure]);
                this._initiate_edition([user_measure]);
                this._initialize_creation();
            }
            return true;
        }
        return false;
    }

    //***************************************************************
    /**
     * Initialize creation, depending on mode
     */
    _initialize_creation() {
        this._hooks = [null];
    }

    /**
     * TODO : derivate in order to allow edition of other element in the process of creation
     * @param {cn_mouse_event} mouse_event
     * @returns {cn_element}
     */
    _find_other_element(mouse_event) {
        if (this._view_overlay) {
            const storey_element = this._view_overlay.find_mouse_element(mouse_event);
            if (!storey_element) return null;
            if (this.element_filter(storey_element.element)) {
                logger.log('other element');
                return storey_element.element;
            }
        }
        return null;
    }

    //***********************************************************************************
    /**
     * Builds a new marker handler.
     * TODO: derivate this in order to manage marker derivates
     * @param {Array<cn_user_measure>} measures
     * @returns {cn_edition_handler}
     */
    _build_edition_handler(measures) {
        const handler = new cn_user_measure_handler(measures, (this._map) ? this._map : this._view_overlay, true);

        return handler;
    }

}

